<div
  [class]="containerClasses()"
  (mouseenter)="setHovered(true)"
  (mouseleave)="setHovered(false)"
  (click)="toggleSelected()"
  tabindex="0"
>
  @if (showCheckbox()) {
    <app-checkbox [checked]="isSelected()">
      <span [class]="textClasses()">{{ text() }}</span>
    </app-checkbox>
  } @else if (showRadioButton()) {
    <app-radio-button
      [controlName]="radioControlName()"
      [value]="radioValue()"
      [label]="text()"
    ></app-radio-button>
  }
  @if (!showCheckbox() && !showRadioButton()) {
    @if (icon() !== '') {
      <svg-icon [src]="icon()" [svgClass]="iconClasses()"></svg-icon>
    }

    <span [class]="textClasses()">{{ text() }}</span>

    <svg-icon
      src="icon_checkmark_2_16px.svg"
      [svgClass]="checkmarkClasses()"
      class="ml-auto"
    ></svg-icon>
  }
</div>
